<template>
  <div class="vld-parent">


    <!-- Subscription overlay -->
    <b-overlay
      :show="show"
      variant="transparent"
      :opacity="1"
      blur="3px"
    >
      <template v-slot:overlay>
        <div class="text-center">
          <p id="cancel-label">
            Please upgrade your subscription to activate this feature
          </p>
          <b-button
            ref="cancel"
            variant="primary"
            aria-describedby="cancel-label"
            @click="upgradeSubscription()"
          >
            Click here to upgrade
          </b-button>
        </div>
      </template>

      <!-- User Interface controls -->

      <b-row>
        <b-col md="9">
          <h4 class="font-weight-bold ml-1">Arbeidslogg</h4>
        </b-col>

        <b-col md="1">
          <div class="float-right">
            <label class="nav-item navbar-text navbar-search-box p-0 active">
              <i class="ion ion-ios-search navbar-icon align-middle"></i>
              <span class="navbar-search-input pl-2">
                <b-form-input
                  class="ml-2"
                  v-model="filter"
                  placeholder="Search"
                ></b-form-input>
              </span>
            </label>
          </div>
        </b-col>
      </b-row>

      <!-- Main table element: one row per order, worklog lines shown on expand -->
      <b-table
        show-empty
        caption-top
        stacked="sm"
        :items="orderGroups"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage"
        :total-rows="totalRows"
        :filter="filter"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        empty-text="There are no worklogs to show"
        @filtered="onFiltered"
      >
        <template v-slot:table-caption>Totalt: {{ orderGroups.length | numeralFormat }} ordre ({{ worklogs.length | numeralFormat }} arbeidslogglinjer)
        </template>

        <template v-slot:cell(ordertitle)="data">
          {{ data.item.ordernumber }} - {{ data.item.customer }}<span v-if="data.item.site"> ({{ data.item.site }})</span>
        </template>

        <template v-slot:cell(totalDuration)="data">
          {{ data.value }} timer
        </template>

        <template v-slot:cell(lastUpdated)="data">
          <span v-if="data.value">{{ $date(data.value).format("DD.MM.YYYY HH:mm") }}</span>
        </template>

        <template v-slot:cell(actions)="row">
          <b-button
            size="sm"
            variant="primary"
            @click="row.toggleDetails"
          >{{ row.detailsShowing ? "Skjul" : "Vis" }} arbeidslogg</b-button>
        </template>

        <template v-slot:row-details="row">
          <b-card>
            <b-table
              striped
              small
              :items="row.item.worklogs"
              :fields="detailFields"
              empty-text="Ingen arbeidslogglinjer"
            >
              <template v-slot:cell(from)="data">
                {{ $date(data.value).format("DD.MM.YYYY HH:mm") }}
              </template>

              <template v-slot:cell(to)="data">
                {{ $date(data.value).format("DD.MM.YYYY HH:mm") }}
              </template>

              <template v-slot:cell(duration)="data">
                {{ data.value }} timer
              </template>
            </b-table>
          </b-card>
        </template>
      </b-table>

      <b-row>
        <b-col
          md="1"
          class="my-1"
        >
          <b-form-group class="mb-0">
            <b-form-select
              v-model="perPage"
              :options="pageOptions"
            ></b-form-select>
          </b-form-group>
        </b-col>

        <b-col
          md="2"
          class="my-1"
        >
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            class="my-0"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-overlay>
  </div>
</template>

<script>
import axios from "axios";

import Vue2Filters from "vue2-filters";
import Datepicker from "vuejs-datepicker";
import VueMoment from "vue-moment";
import moment from "moment";



export default {
  components: {
    
    Datepicker,
    VueMoment,
    moment,
  },
  mixins: [Vue2Filters.mixin],
  data() {
    return {
      worklogs: [],
      orderGroups: [],
      lastUpdate: {},
      fromDate: {},
      toDate: {},
      disabledDates: {},
      fields: [
        { key: "ordertitle", label: "Ordre", sortable: true },
        { key: "count", label: "Antall linjer", sortable: true },
        { key: "totalDuration", label: "Timer totalt", sortable: true },
        { key: "lastUpdated", label: "Sist oppdatert", sortable: true },
        { key: "actions", label: "" },
      ],
      detailFields: [
        {
          key: "action",
          label: "Hendelse",
          sortable: true,
        },

        {
          key: "from",
          label: "Fra",
          sortable: true,
        },

        {
          key: "to",
          label: "Til",
          sortable: false,
        },
        {
          key: "duration",
          label: "Antall timer",
          sortable: false,
        },
        {
          key: "description",
          label: "Beskrivelse",
          sortable: false,
          tdClass: "worklogmaxwidth",
        },

      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 100,
      pageOptions: [25, 50, 100, 250, 500, 1000],
      sortBy: "lastUpdated",
      sortDesc: true,
      sortDirection: "desc",
      filter: null,
      limit: 1000,
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
      isLoading: false,
      fullPage: true,
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
    sumWorklogsTotal() {
      return this.worklogs.length;
    },
  },
  methods: {
    getWorklogs() {
      this.isLoading = true;
      var company = localStorage.getItem("company");

      axios
        .get("https://api.eines-as.no/worklogs?_limit=-1&_sort=createdAt:DESC&_where[company]=" + company)
        .then((res) => {
          this.worklogs = res.data;
          this.buildOrderGroups();
          this.isLoading = false;
        });
    },
    buildOrderGroups() {
      var groups = {};
      var list = [];

      this.worklogs.forEach((worklog) => {
        var key = worklog.order || worklog.ordernumber || "ukjent";

        if (!groups[key]) {
          groups[key] = {
            order: worklog.order,
            ordernumber: worklog.ordernumber,
            customer: worklog.customer,
            site: worklog.site,
            worklogs: [],
            _showDetails: false,
          };
          list.push(groups[key]);
        }

        groups[key].worklogs.push(worklog);
      });

      list.forEach((group) => {
        group.count = group.worklogs.length;
        group.totalDuration = group.worklogs.reduce(function (n, worklog) {
          return n + (worklog.duration || 0);
        }, 0);
        group.lastUpdated = group.worklogs.reduce(function (latest, worklog) {
          if (!latest) return worklog.createdAt;
          return new Date(worklog.createdAt) > new Date(latest) ? worklog.createdAt : latest;
        }, null);
      });

      list.sort(function (a, b) {
        return new Date(b.lastUpdated) - new Date(a.lastUpdated);
      });

      this.orderGroups = list;
      this.totalRows = list.length;
    },
    updateWorklogs() {
      this.isLoading = true;
      axios
        .get("https://api.eines-as.no/worklogs?_limit=-1&_sort=createdAt:DESC&_where[company]=" + company)
        .then((res) => {
          this.worklogs = res.data;
          this.totalRows = this.worklogs.length
          this.isLoading = false;
        });
    },
  },
  created: function () {
    this.getWorklogs();
  },
};
</script>

<style lang="css">
.country-flag {
  max-width: 20px;
  box-shadow: inset 0px 0px 10px rgba(0, 0, 0, 0.9);
}

.worklogmaxwidth {
  max-width: 400px;
}

/*
 * Link
 */

/* Links */

.link {
  color: #484848;
}

/* unvisited link */
.link:link {
  color: #484848 !important;
}

/* visited link */
.link:visited {
  color: #484848 !important;
}

/* mouse over link */
.link:hover {
  color: #6e6e6e !important;
}

/* selected link */
.link:active {
  color: #484848 !important;
}
</style>